// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import AppsFormDateTimeField from './apps_form_datetime_field';

export default AppsFormDateTimeField;
